import * as React from "react";
import Style from "../../_data/models/Style";
import Meta from "../../_data/models/Meta";
import {formatWithTags} from "../../_helpers/utils";
import {CommentsState} from "../../_definitions/styleteq";
import CommentsContainer from "../../comment/containers/CommentsContainer";
import UserProfileHeaderComponent from "../../_widgets/user/UserProfileHeaderComponent";
import LikeContainer from "../../_widgets/like/LikeContainer";
import {History} from "history";
import BreadcrumbsComponent from "../../_widgets/breadcrumbs/BreadcrumbsComponent";
import LoadingIndicatorComponent from "../../_widgets/loadingIndicator/LoadingIndicatorComponent"

interface Props {
    style: Style;
    loading: boolean;
    comments: CommentsState;
    loadMoreComments: (meta: Meta) => void;
    history: History;
    notFoundStyle: boolean;
}

const StyleComponent = (props: Props) => {
    
    const {style, loading, comments, loadMoreComments, notFoundStyle} = props;

    if (!style && loading)
        return (
            <div className="row expanded">
                <LoadingIndicatorComponent message="Loading Style..."/>
            </div>
        );    
    else if((!loading && notFoundStyle) || (!loading && style === undefined))
        return (
            <div className="row expanded" style={{paddingLeft:'1rem', paddingTop:'1rem'}}>
                <h1>Style not found. :(</h1>
            </div>
        );
    else
        return (
            <div>
                <div className="row">
                    <BreadcrumbsComponent>
                        <li>
                            <a href="javascript: history.go(-1)">
                                Back
                            </a>
                        </li>
                        <li>View Image</li>
                    </BreadcrumbsComponent>
                </div>

                <UserProfileHeaderComponent user={style.user}/>

                <div className="row newsfeed-modal">
                    <div className="large-12 columns">
                        <div className="callout">
                            <div className="row">
                                <div className="large-6 columns main-post">
                                    <div className="post-img v-align-center">
                                        <img src={style.primaryPictureUrl} alt=""/>
                                    </div>

                                    {/*<ul className="list-inline table justified">*/}
                                    {/*<li className="text-center">*/}
                                    {/*<a href="#">*/}
                                    {/*<i className="fa fa-share"/>&nbsp; Share*/}
                                    {/*</a>*/}
                                    {/*</li>*/}
                                    {/*<li className="text-center">*/}
                                    {/*<a href="edit-image.html">*/}
                                    {/*<i className="fa fa-edit"/>&nbsp; Edit*/}
                                    {/*</a>*/}
                                    {/*</li>*/}
                                    {/*</ul>*/}
                                </div>

                                <div className="large-6 columns">
                                    <div className="row p1 bb-1">
                                        <div className="large-12 columns paddingless">
                                            <p className="mt-1"
                                               style={{wordWrap: 'break-word'}}>{formatWithTags(style.description)}</p>
                                        </div>
                                    </div>

                                    <div className="row bb-1">
                                        <div className="large-12 columns pt-half pb-half">
                                            <ul className="list-inline marginless newsfeed-rgfont">
                                                <LikeContainer model={style}/>
                                                <li>
                                                    <i className="fa fa-comment-o fa-fw"/> {style.commentCount} Comments
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <CommentsContainer items={comments} loadMoreComments={loadMoreComments}/>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
};

export default StyleComponent;


// WEBPACK FOOTER //
// ./app/client/style/components/StyleComponent.tsx